<script>
  import options from './SourceExternalLinks.options'
  export default options
</script>

<template>
  <article v-if="links && links.length" class="kb-source-external-links">

    <h2 class="kb-source-external-links__title">
      Læs mere om {{ name }}:
    </h2>

    <div class="kb-source-external-links__link-list">
      <a v-for="(link, index) in links" :key="index" :href="link.url" target="_blank" class="kb-source-external-links__link">
        {{ link.text }}
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" width="16" height="16" viewBox="0 0 16 16">
          <path fill="#3C3C3C" fill-rule="evenodd" d="m12.978 2.708-3.864-.191-.049-.987 4.37.217c.279.014.516.246.53.518l.216 4.37-1.011-.05-.192-3.877Zm-8.924 8.23 6.734-6.734.707.707-6.734 6.734-.707-.707ZM1.5 3H1v12h12V8.312h-1V14H2V4h5.688V3H1.5Z" clip-rule="evenodd"/>
        </svg>
      </a>
    </div>

  </article>
</template>
